<template>
<div class="row condense-12">
  <div class="col-12">
    <div class="row text-left">
        <div class="col-3 lbl-left"><label>Numéro de dossier : </label></div> <p class="col-3"> {{ dossier.numeroDossier }} </p>
    </div>
    <div class="row text-left">
      <div class="col-3 lbl-left"><label>Numéro Cardex : </label></div> <p class="col-3"> {{ dossier.numeroCardex }} </p>
    </div>
    <div class="row text-left">
        <div class="col-2 lbl-left"><label>Rapporté par : </label></div> <p class="col-10 text-left">{{ narration.rapporteParDescription }}</p>
    </div>
    <div class="row text-left">
        <div class="col-2 lbl-left"><label>Montant : </label></div> <p class="col-4 text-left"> {{ narration.montant }} </p>
        <div class="col-2 lbl-left"><label>Confidentialité : </label></div> <p class="col-4 text-left"> {{ narration.confidentialiteAfficher }} </p>
    </div>

    <hr>
      <div class="row text-left">
          <p> <span v-html="narration.texteHTML" ></span></p>
      </div>
    <hr>
  </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CanevasNarrationCDX0015",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    this.genererDonneesAffichage()
  },
  created() {
    this.CONFIDENTIALITE_NE_PAS_AFFICHER = "8"
  },
  data() {
    return {
      donneesAffichage: {},
    }
  },
  computed: {
    ...mapGetters({
        narration: "narration/narration",
        dossier: "dossier/dossier"
    }),
  },
  methods: {
    genererDonneesAffichage() {
      this.$emit("isDataLoaded", true);
    },
  },
};
</script>